export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.bfeaf231.png";